import { IOrder } from '../../../../../app/entities/Order'
import styles from '../styles.module.css'
import PrimaryButton from '../../../global/components/buttons/primary-button/PrimaryButton'
import { MouseEventHandler, useEffect, useState } from 'react'
import { UNIVERSAL_TR_ORDER_NUMBERS_ARRAY } from '../../../global/constants/tire-rack-order'
import { getAllTireRackOrderNumbers } from '../../../global/utils/tire-rack-orders'

interface TireRackOrderEntryProps {
  handleOpenEditTireRackOrder: MouseEventHandler
  order: IOrder | null
  isDelivery: boolean
}

const TRO_NUMBERS_TO_NOT_DISPLAY = [...UNIVERSAL_TR_ORDER_NUMBERS_ARRAY]

export default function TireRackOrderEntry(props: TireRackOrderEntryProps) {
  const { handleOpenEditTireRackOrder, order, isDelivery } = props

  const [displayOrderNumbers, setDisplayOrderNumbers] = useState('')

  useEffect(() => {
    const orderNumbers = getAllTireRackOrderNumbers(order ?? ({} as IOrder))

    const filteredOrderNumbers = orderNumbers
      .filter((num) => !TRO_NUMBERS_TO_NOT_DISPLAY.includes(num))
      .join(', ')

    setDisplayOrderNumbers(
      orderNumbers.length > 0 ? filteredOrderNumbers : 'No Tire Rack Order',
    )
  }, [order])

  return (
    <div className={styles.tireRackOrderContainer}>
      <div className={styles.tireRackOrderLeftContainer}>
        <div className={styles.tireRackOrderHeader}>Tire Rack Order</div>
        <div>{displayOrderNumbers}</div>
      </div>
      {!isDelivery && (
        <div className={styles.tireRackOrderRightContainer}>
          <PrimaryButton
            buttonName='Edit'
            onClick={handleOpenEditTireRackOrder}
            style={{ minWidth: '10px', width: '70px' }}
          />
        </div>
      )}
    </div>
  )
}
